import { render, staticRenderFns } from "./old-mother-tree.vue?vue&type=template&id=daa63d0c&scoped=true&"
import script from "./old-mother-tree.vue?vue&type=script&lang=js&"
export * from "./old-mother-tree.vue?vue&type=script&lang=js&"
import style0 from "./old-mother-tree.vue?vue&type=style&index=0&id=daa63d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa63d0c",
  null
  
)

export default component.exports